import { config } from 'client/hooks/config';
import type * as api from 'common/types/api';
import { Api } from 'common/utils/api';
import { isNotNullOrUndefined } from 'common/utils/ObjectUtils';
import { useQuery } from 'react-query';

type Response = api.GetPrimaryAttendeeResponse;

export function useGetPrimaryAttendee(procedureId: number | undefined) {
    const { key, path } = config.attendee.primary(procedureId || 0);

    const result = useQuery(key, () => Api.get<Response>({ path }), {
        refetchInterval: 4000,

        enabled: isNotNullOrUndefined(procedureId),
    });

    return {
        primaryAttendee: result.data,
        isLoading: result.isLoading,
        isFetching: result.isFetching,
    };
}
